<template>
  <Card variant="primary" size="medium">
    <StatsGrid>
      <StatGroup v-for="stat in stats" :key="stat.label" :label="stat.label">
        <View gap="xs" align="baseline" wrap="wrap">
          <Text variant="h3" as="div">{{ stat.value }}</Text>
          <Text v-if="stat.note" variant="body-medium" color="secondary">{{ stat.note }}</Text>
        </View>
      </StatGroup>
    </StatsGrid>
  </Card>
</template>

<script setup lang="ts">
import { format } from 'date-fns';
import { computed } from 'vue';

import { Card, StatGroup, StatsGrid, Text, View } from '@tallo/design-system';
import { BuildingStatisticsDto, PropertyListItemDto } from '@tallo/investor/property';
import { PropertyStatus } from '@tallo/property';

const props = defineProps<{
  units: PropertyListItemDto[];
  /** Undefined while it loads: the figures show as dashes rather than zeros that would read as none */
  statistics: BuildingStatisticsDto | undefined;
}>();

const stats = computed(() => {
  const numbers = props.statistics;
  const rented = props.units.filter((unit) => unit.status === PropertyStatus.RENTED_OUT).length;

  return [
    { label: 'Occupancy', value: rented, note: `of ${props.units.length} rented` },
    {
      label: 'Leads · 30 days',
      value: numbers?.leads ?? '–',
      note: numbers ? `· ${numbers.qualifiedLeads} qualified` : '',
    },
    {
      label: 'Showings',
      value: numbers?.showingsBooked ?? '–',
      note: numbers?.nextShowingAt ? `· next ${format(new Date(numbers.nextShowingAt), 'EEE h:mm a')}` : '',
    },
    {
      label: 'Applications',
      value: numbers?.applicationsSent ?? '–',
      note: numbers ? `· ${numbers.applicationsCompleted} completed` : '',
    },
  ];
});
</script>
